import { render } from "./Page404.vue?vue&type=template&id=2df96e51&bindings={}"
import script from "./Page404.vue?vue&type=script&lang=js"
export * from "./Page404.vue?vue&type=script&lang=js"
script.render = render

export default script